import { render, staticRenderFns } from "./AllergenAnalysisResults.vue?vue&type=template&id=9845f9f4&scoped=true"
import script from "./AllergenAnalysisResults.vue?vue&type=script&lang=ts"
export * from "./AllergenAnalysisResults.vue?vue&type=script&lang=ts"
import style0 from "./AllergenAnalysisResults.vue?vue&type=style&index=0&id=9845f9f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9845f9f4",
  null
  
)

export default component.exports